import { createContext, useContext } from "react";
import { type DBPool } from "../duckdb";

export interface DatabaseContextType {
  dbPool: DBPool | null;
  isLoading: boolean;
  error: string | null;
}

export const DatabaseContext = createContext<DatabaseContextType | undefined>(undefined);

export function useDatabase(): DatabaseContextType {
  const context = useContext(DatabaseContext);
  if (context === undefined) {
    throw new Error("useDatabase must be used within a DatabaseProvider");
  }
  return context;
}
